'use strict';

var utils = function () {
  var _render = function _render(html, toAppend) {
    $(toAppend).append(html);
    return $(html);
  };

  var _makeRequest = function _makeRequest(url, method, callback) {
    var request = new XMLHttpRequest();
    request.open(method || 'GET', url, true);
    request.onreadystatechange = function (aEvt) {
      if (request.readyState == 4) {
        if (request.status == 200) callback(request.responseText);else console.log("Error loading page\n");
      }
    };
    request.send(null);
  };

  var _animateScroll = function _animateScroll($targetelem) {
    var top = $targetelem.offset().top - 40;
    var body = $('html, body');
    if ($(window).width() < 769) {
      body.stop().animate({ scrollTop: top }, 100, 'linear');
    }
  };

  return {
    render: _render,
    makeRequest: _makeRequest,
    animateScroll: _animateScroll
  };
}();